import { inject, Service } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { palletsActions } from '../actions/pallets.actions';
import { PalletStatus } from '../models';
import { selectHasMore, selectLoaded, selectLoading, selectPage, selectPallet, selectPallets, selectSaving, selectStatus } from '../selectors/pallets.selector';

@Service()
export class PalletsFacade {
    private readonly store = inject(Store);
    private readonly actions = inject(Actions);

    readonly pallets = this.store.selectSignal(selectPallets);
    readonly status = this.store.selectSignal(selectStatus);
    readonly page = this.store.selectSignal(selectPage);
    readonly hasMore = this.store.selectSignal(selectHasMore);
    readonly pallet = this.store.selectSignal(selectPallet);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly generated$ = this.actions.pipe(ofType(palletsActions.generatePalletsSuccess));
    readonly closed$ = this.actions.pipe(ofType(palletsActions.closePalletSuccess));
    readonly palletLoaded$ = this.actions.pipe(ofType(palletsActions.loadPalletSuccess));
    readonly palletLoadError$ = this.actions.pipe(ofType(palletsActions.loadPalletError));

    loadPallets(status: PalletStatus): void {
        this.store.dispatch(palletsActions.loadPallets({ status, page: 1 }));
    }

    loadMorePallets(): void {
        this.store.dispatch(palletsActions.loadPallets({ status: this.status(), page: this.page() + 1 }));
    }

    generatePallets(quantity: number): void {
        this.store.dispatch(palletsActions.generatePallets({ quantity }));
    }

    printPallet(code: string): void {
        this.store.dispatch(palletsActions.printPallet({ code }));
    }

    loadPallet(code: string): void {
        this.store.dispatch(palletsActions.loadPallet({ code }));
    }

    addCarton(code: string, cartonCode: string): void {
        this.store.dispatch(palletsActions.addCarton({ code, cartonCode }));
    }

    removeCarton(code: string, cartonCode: string): void {
        this.store.dispatch(palletsActions.removeCarton({ code, cartonCode }));
    }

    closePallet(code: string): void {
        this.store.dispatch(palletsActions.closePallet({ code }));
    }

    clear(): void {
        this.store.dispatch(palletsActions.clear());
    }
}
